export default __webpack_public_path__ + "57d490a5e180afda5286c72283b50aab.png";